import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Table, Trash, Star } from "@phosphor-icons/react";
import Layout from "../components/Layout";
import EmptyState from "../components/EmptyState";
import api, { apiErrorMessage } from "../lib/api";

const FIELD_LABELS = {
  bill_date: "Bill Date", bill_number: "Bill Number", item_name: "Item Name",
  quantity: "Quantity", amount: "Amount", floor: "Floor", salesman: "Salesman",
};

export default function Templates() {
  const [tmpls, setTmpls] = useState(null);

  const load = () => api.get("/templates").then((r) => setTmpls(r.data)).catch(() => setTmpls([]));
  useEffect(() => { load(); }, []);

  const del = async (t) => {
    try {
      await api.delete(`/templates/${t.id}`);
      toast.success("Template deleted");
      load();
    } catch (e) {
      toast.error(apiErrorMessage(e.response?.data?.detail) || "Failed");
    }
  };

  if (tmpls === null) {
    return <Layout title="Templates"><div className="h-64 animate-pulse rounded-lg border border-slate-200 bg-white" /></Layout>;
  }

  if (tmpls.length === 0) {
    return (
      <Layout title="Templates">
        <EmptyState icon={Table} title="No mapping templates" message="Templates are created automatically when you save a column mapping during upload." testId="templates-empty" />
      </Layout>
    );
  }

  return (
    <Layout title="Templates">
      <div className="animate-fade-in space-y-4">
        <p className="text-sm text-slate-500">Reusable Excel column mappings. The last-used template is auto-loaded on your next upload.</p>
        <div className="grid gap-4 md:grid-cols-2">
          {tmpls.map((t) => (
            <div key={t.id} className="rounded-lg border border-slate-200 bg-white p-5" data-testid={`template-${t.id}`}>
              <div className="mb-3 flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <h3 className="font-display text-base font-bold text-slate-900">{t.name}</h3>
                  {t.is_last_used && (
                    <span className="flex items-center gap-1 rounded-full bg-blue-100 px-2 py-0.5 text-[11px] font-semibold text-blue-700">
                      <Star size={11} weight="fill" /> Last used
                    </span>
                  )}
                </div>
                <button onClick={() => del(t)} data-testid={`delete-template-${t.id}`} className="rounded-md border border-slate-300 p-1.5 text-slate-500 hover:bg-red-50 hover:text-red-600">
                  <Trash size={16} />
                </button>
              </div>
              <div className="space-y-1">
                {Object.entries(FIELD_LABELS).map(([k, label]) => (
                  <div key={k} className="flex items-center justify-between text-sm">
                    <span className="text-slate-500">{label}</span>
                    <span className="font-mono-data text-slate-800">{t.mapping[k] || "—"}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
